@if (desktopMode) {
  <div class="tenant-selector-main-container">
    <div class="tenant-search-container">
      <app-ui-autocomplete
        [placeholder]="'search'"
        [options]="searchableTenants"
        [searchTerm]="form.searchTerm"
        [floatLabel]="'always'"
        [showList]="false"
        [showClearButton]="true"
      ></app-ui-autocomplete>
    </div>
    <div class="tenant-list-container">
      @for (tenant of filteredTenants; track tenant.id) {
        <div
          class="tenant-single-container"
          (click)="selectionChanged(tenant)"
          [ngClass]="tenant.id === currentTenantId ? 'selected-tenant' : ''"
        >
          <span class="tenant-image">
            @if (tenant.logo) {
              <img [src]="tenant.logo | appendDomain" alt="{{ 'tenantLogo' | translate }}" />
            } @else {
              <div class="blank-logo-div"></div>
            }
          </span>
          <span class="tenant-main-info">
            <h3>{{ tenant.name }}</h3>
            <h4>{{ tenant.accountType | translate }}</h4>
          </span>
          <span class="tenant-department-count">
            {{ tenant.departmentInfos?.length }} {{ 'dep.' | translate }}
          </span>
          <span class="tenant-status">
            <app-ui-pill [name]="tenant.status" [module]="mainModulesEnum.Tenant"></app-ui-pill>
          </span>
          <span class="tenant-select-button">
            <app-ui-button buttonType="icon-button" icon="chevron_right"></app-ui-button>
          </span>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="tenant-selector-main-container-mobile">
    <div class="mobile-dialog-heading">
      <span class="mobile-heading-title">
        {{ 'Tenant' | translate }}
      </span>
      <mat-icon (click)="closeDialog()">close</mat-icon>
    </div>
    <div class="dialog-search-container-mobile">
      <app-ui-autocomplete
        [placeholder]="'search'"
        [options]="searchableTenants"
        [searchTerm]="form.searchTerm"
        [floatLabel]="'always'"
        [showList]="false"
        [showClearButton]="true"
      ></app-ui-autocomplete>
    </div>
    <div class="tenant-list-container">
      @for (tenant of filteredTenants; track tenant.id) {
        <div
          class="tenant-single-container"
          (click)="selectionChanged(tenant)"
          [ngClass]="tenant.id === currentTenantId ? 'selected-tenant' : ''"
        >
          <span class="tenant-image">
            @if (tenant.logo) {
              <img [src]="tenant.logo | appendDomain" alt="{{ 'tenantLogo' | translate }}" />
            } @else {
              <div class="blank-logo-div"></div>
            }
          </span>
          <span class="tenant-main-info">
            <span>
              <h3>
                {{ tenant.name.length > 30 ? (tenant.name | slice: 0 : 30) + '...' : tenant.name }}
              </h3>
              <app-ui-pill [name]="tenant.status" [module]="mainModulesEnum.Tenant"></app-ui-pill>
            </span>
            <span>
              <h4>{{ tenant.accountType | translate }}</h4>
            </span>
          </span>
        </div>
      }
    </div>
  </div>
}
